import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CustomNavbar from '../../components/CustomNavbar';
import { Row, Container, Col, Card, Form, Spinner, Button } from 'react-bootstrap';
import SidebarDashboard from '../../components/SidebarDashboard';
import { Bar, Doughnut, Pie } from 'react-chartjs-2';
import moment from 'moment';
import { getChartsData } from '../../redux/dashboardPlazasJefes/actions';
import { getMonthName } from '../../components/GetMonth';
import busiman from '../../images/businessman.png';
import tea from '../../images/teacher.png';
import jobOf from '../../images/job-offer.png';
const cardStyle = {width: '6rem', fontSize: 'none'};
const cardTitleStyle = { fontSize: '2rem' };

const DashboardPositionH = props => {
  //*States
  const [show, setShow] = useState(false);
  //const [fecha_min, setFechaMin] = useState(moment().startOf('month').subtract(1, 'month').format('yyyy-MM-DD'));
  //const [fecha_max, setFechaMax] = useState(moment().endOf('month').subtract(1, 'month').format('yyyy-MM-DD'));
  const [validated, setValidated] = useState(false);
  const [year, setYear] = useState(moment().year().toString())
  const dispatch = useDispatch();
  //*Redux
  const chartData = useSelector(store => store.plazasJefes.plazasJefes);
  const dataLoader = useSelector(store => store.plazasJefes.loading);
  const { empleadosXempresa, 
          puestos_existentes, 
          puestos_vacantes,
          puestos_cubiertos,
          personal_tipo_relacion,
          //entrada,
          //baja,
          entrada_anual,
          entrada_baja,
          empleado_zona,
          empleado_genero,
          empleado_antiguedad,
          //empleado_departamento,
          empleado_formacion,
          empleado_centro_costo,
          Datosxpuesto } = chartData;

  //*Empleados por centro de costo
  const ceCoData = {
    labels: [],
    data: []
  };

  if(empleado_centro_costo && empleado_centro_costo.length > 0){
    empleado_centro_costo.map(item => {
      ceCoData.labels = [...ceCoData.labels, item.centro];
      ceCoData.data = [...ceCoData.data, item.conteo]
    });
  }

  const skipped = (ctx, value) => ctx.p0.skip || ctx.p1.skip ? value : undefined;
  const down = (ctx, value) => ctx.p0.parsed.y > ctx.p1.parsed.y ? value : undefined;

  const graphceCo = {
    labels:  ceCoData.labels,
    datasets: [{
      label: '# empleados por CeCo',
      data: ceCoData.data,
      borderColor: 'rgb(75, 192, 192)',
      segment: {
        borderColor: ctx => skipped(ctx, 'rgb(0,0,0,0.2)') || down(ctx, 'rgb(192,75,75)'),
        borderDash: ctx => skipped(ctx, [6, 6]),
      },
      backgroundColor: [
        '#0070b8',
        '#0062a1',
        '#00548a',
        '#004673',
        '#00385c',
        '#002a45',
        '#001c2e',
        '#3f93c9',
        '#5fa5d2',
        '#7fb7db',
        '#9fc9e4',
        '#bfdbed',
        '#dfedf6',
      ],
      hoverBackgorundColor: [
        '#0070b8',
        '#0062a1',
        '#00548a',
        '#004673',
        '#00385c',
        '#002a45',
        '#001c2e',
        '#3f93c9',
        '#5fa5d2',
        '#7fb7db',
        '#9fc9e4',
        '#bfdbed',
        '#dfedf6',
      ]
    }]
  }

  //* Personal tipo de relación
  const persTypeRel = {labels: [], data: []}
  if(personal_tipo_relacion && personal_tipo_relacion.length > 0){
    personal_tipo_relacion.map(item => {
      persTypeRel.labels = [...persTypeRel.labels, item.relacion];
      persTypeRel.data = [...persTypeRel.data, item.conteo];
    });
  }

  const graphTypeRel = {
    labels: persTypeRel.labels,
    datasets: [
      {
        label: 'Tipo de relación',
        data: persTypeRel.data,
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  //* Contrataciones vs Salidas
  const contVsSal = {labels: [], dataIn: [], dataOu: []};
  if(entrada_anual && entrada_anual.length > 0 && entrada_baja && entrada_baja.length > 0){
    entrada_anual.map(item => {
      contVsSal.labels = [...contVsSal.labels, getMonthName(item.mes)];
      contVsSal.dataIn = [...contVsSal.dataIn, item.conteo]
    });
    entrada_baja.map(item => {
      contVsSal.dataOu = [...contVsSal.dataOu, item.conteo];
    });
  }

  const graphContVsSal = {
    labels: contVsSal.labels,
    datasets: [
      {
        label: 'Contrataciones',
        data: contVsSal.dataIn,
        backgroundColor: [
          '#0070b8',
        ],
        hoverBackgorundColor: [
          '#0070b8',
        ]
      },
      {
        label: 'Salidas',
        data: contVsSal.dataOu,
        backgroundColor: [
          '#e6150f',        ],
        hoverBackgorundColor: [
          '#e6150f',
        ]
      }
    ]
  };

  //* Empleados por empresa
  const empxEmp = {labels: [], data: []};
  if(empleadosXempresa && empleadosXempresa.length > 0){
    empleadosXempresa.map(item => {
      empxEmp.labels = [...empxEmp.labels, item.empresa];
      empxEmp.data = [...empxEmp.data, item.conteo];
    });
  }

  const graphpersonalPaisEmpresaData = {
    labels: empxEmp.labels,
    datasets: [{
      label: '# de empleados a su cargo',
      data: empxEmp.data,
      borderColor: 'rgb(75, 192, 192)',
      segment: {
        borderColor: ctx => skipped(ctx, 'rgb(0,0,0,0.2)') || down(ctx, 'rgb(192,75,75)'),
        borderDash: ctx => skipped(ctx, [6, 6]),
      },
      backgroundColor: [
        '#0070b8',
        '#0062a1',
        '#00548a',
        '#004673',
        '#00385c',
        '#002a45',
        '#001c2e',
        '#3f93c9',
        '#5fa5d2',
        '#7fb7db',
        '#9fc9e4',
        '#bfdbed',
        '#dfedf6',
      ],
      hoverBackgorundColor: [
        '#0070b8',
        '#0062a1',
        '#00548a',
        '#004673',
        '#00385c',
        '#002a45',
        '#001c2e',
        '#1f81c0',	
        '#3f93c9',	
        '#5fa5d2',	
        '#7fb7db',	
        '#9fc9e4',	
        '#bfdbed',	
        '#dfedf6',
      ]
    }]
  }

  //* Personal por zona
  const perxzona = {labels: [], data: []}
  if(empleado_zona && empleado_zona.length > 0){
    empleado_zona.map(item => {
      perxzona.labels = [...perxzona.labels, item.zona];
      perxzona.data = [...perxzona.data, item.conteo];
    });
  }

  const graphPersonalZonaData = {
    labels: perxzona.labels,
    datasets: [{
      label: "# empleados por zona",
      borderColor: 'rgb(75, 192, 192)',
      segment: {
        borderColor: ctx => skipped(ctx, 'rgb(0,0,0,0.2)') || down(ctx, 'rgb(192,75,75)'),
        borderDash: ctx => skipped(ctx, [6, 6]),
      },
      data: perxzona.data,
      backgroundColor: [
        '#0070b8',
        '#0062a1',
        '#00548a',
        '#004673',
        '#00385c',
        '#002a45',
        '#001c2e',
        '#3f93c9',
        '#5fa5d2',
        '#7fb7db',
        '#9fc9e4',
        '#bfdbed',
        '#dfedf6',
      ],
      hoverBackgorundColor: [
        '#0070b8',
        '#0062a1',
        '#00548a',
        '#004673',
        '#00385c',
        '#002a45',
        '#001c2e',
        '#3f93c9',
        '#5fa5d2',
        '#7fb7db',
        '#9fc9e4',
        '#bfdbed',
        '#dfedf6',
      ]
    }]
  }

  //* Personal por formación
  const perxform = {labels: [], data: []};
  if(empleado_formacion && empleado_formacion.length > 0){
    empleado_formacion.map(item => {
      perxform.labels = [...perxform.labels, item.formacion__descripcion];
      perxform.data = [...perxform.data, item.conteo];
    });
  }

  const graphFormAcademicData = {
    labels: perxform.labels,
    datasets: [{
      label: '# empleados por formación',
      data: perxform.data,
      borderColor: 'rgb(75, 192, 192)',
      segment: {
        borderColor: ctx => skipped(ctx, 'rgb(0,0,0,0.2)') || down(ctx, 'rgb(192,75,75)'),
        borderDash: ctx => skipped(ctx, [6, 6]),
      },
      backgroundColor: [
        '#0070b8',
        '#0062a1',
        '#00548a',
        '#004673',
        '#00385c',
        '#002a45',
        '#001c2e',
        '#3f93c9',
        '#5fa5d2',
        '#7fb7db',
        '#9fc9e4',
        '#bfdbed',
        '#dfedf6',
      ],
      hoverBackgorundColor: [
        '#0070b8',
        '#0062a1',
        '#00548a',
        '#004673',
        '#00385c',
        '#002a45',
        '#001c2e',
        '#3f93c9',
        '#5fa5d2',
        '#7fb7db',
        '#9fc9e4',
        '#bfdbed',
        '#dfedf6',
      ]
    }]
  }

  //* Personal por genero
  const persGenero = {labels: [], data: []};
  if(empleado_genero && empleado_genero.length > 0){
    empleado_genero.map(item => {
      persGenero.labels = [...persGenero.labels, item.genero];
      persGenero.data = [...persGenero.data, item.conteo];
    });
  }

  const graphpersonalGenero = {
    labels: persGenero.labels, 
    datasets: [{
      label: '# empleados por género',
      borderColor: 'rgb(75, 192, 192)',
      segment: {
        borderColor: ctx => skipped(ctx, 'rgb(0,0,0,0.2)') || down(ctx, 'rgb(192,75,75)'),
        borderDash: ctx => skipped(ctx, [6, 6]),
      },
      data: persGenero.data,
      backgroundColor: [
        '#FF00FF',
        '#0c87e7',
      ],
      hoverBackgorundColor: [
        '#FF00FF',
        '#0c87e7',
      ]
    }]
  }

  //* Personal por antiguedad

  const persAnt = {labels: [], data: []};
  if(empleado_antiguedad && empleado_antiguedad.length > 0){
    empleado_antiguedad.map(item => {
      persAnt.labels = [...persAnt.labels, `${item.antiguedad} años`];
      persAnt.data = [...persAnt.data, item.conteo];
    });
  }

  const graphAntLaboralData = {
    labels: persAnt.labels
    ,
    datasets: [{
      label: '# empleados por antigüedad laboral',
      data: persAnt.data,
      borderColor: 'rgb(75, 192, 192)',
      segment: {
        borderColor: ctx => skipped(ctx, 'rgb(0,0,0,0.2)') || down(ctx, 'rgb(192,75,75)'),
        borderDash: ctx => skipped(ctx, [6, 6]),
      },
      backgroundColor: [
        '#0070b8',
        '#0062a1',
        '#00548a',
        '#004673',
        '#00385c',
        '#002a45',
        '#001c2e',
        '#3f93c9',
        '#5fa5d2',
        '#7fb7db',
        '#9fc9e4',
        '#bfdbed',
        '#dfedf6',
      ],
      hoverBackgorundColor: [
        '#0070b8',
        '#0062a1',
        '#00548a',
        '#004673',
        '#00385c',
        '#002a45',
        '#001c2e',
        '#3f93c9',
        '#5fa5d2',
        '#7fb7db',
        '#9fc9e4',
        '#bfdbed',
        '#dfedf6',
      ]
    }]
  }

  //* plazas cubiertas
  const plazasVanc = {labels: [], dataVanc: [], dataCub: []};
  if(Datosxpuesto && Datosxpuesto.length > 0){
    Datosxpuesto.map(item => {
      plazasVanc.labels = [...plazasVanc.labels, item.puesto];
      plazasVanc.dataVanc = [...plazasVanc.dataVanc, item.vacantes.conteo];
      plazasVanc.dataCub = [...plazasVanc.dataCub, item.cubiertos.conteo];
    });
  }

  const graphEstandarData = {
    labels: plazasVanc.labels,
    datasets: [
      {
        label: 'Plazas cubiertas',
        data: plazasVanc.dataCub,
        backgroundColor: [
          '#0070b8',
        ],
        hoverBackgorundColor: [
          '#0070b8',

        ]
      },
      {
        label: 'Plazas vacantes',
        data: plazasVanc.dataVanc,
        backgroundColor: [
          '#00385c',        ],
        hoverBackgorundColor: [
          '#00385c',
        ]
      }]
  }

  //*Métodos
  useEffect(() => {
    dispatch(getChartsData({
      fecha_min: `${year}-01-01`,
      fecha_max: `${year}-12-31`,
    }));
  }, [dispatch, year]);

  const onSubmit = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setYear(e.target.year.value);

    // if (moment(e.target.fecha_min.value) > moment(e.target.fecha_max.value)){
    //   toastr.error('La fecha inicial no pueder ser mayor a la fecha final del rango');
    // }
    // else {
    //   setFechaMin(e.target.fecha_min.value);
    //   setFechaMax(e.target.fecha_max.value);
    // }
  }

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="pcj-header-dashboard">
          <Container fluid>
            <Row>
              <Col sm={12}>
                <Card className="border-0 bg-transparent">
                  <Card.Body>
                    <Row>
                      <Col md="4" className="mb-2 mb-sm-0">
                        <Card className="border-0 ">
                          <Card.Body className="dashboard-card dashboard-card-jo">
                            <div >
                              <h1 className="font-weight-bold title" style={{fontSize: '5rem'}}>{
                                dataLoader ? (
                                  <div className="d-flex">
                                    <Spinner
                                      animation="border"
                                      role="status"
                                      className="d-flex justify-content-center" />
                                  </div>
                                ): puestos_existentes && puestos_existentes.length > 0 ? puestos_existentes[0].conteo : 0 }</h1>
                              <h6 className="font-weight-bold text-uppercase mt-3">plazas actuales</h6>
                            </div>
                            <img className="icon" style={cardStyle} src={busiman} alt="plazas actuales" srcset={busiman} />
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col md="4" className="mb-2 mb-sm-0">
                        <Card className="border-0 ">
                          <Card.Body className="dashboard-card dashboard-card-re">
                            <div >
                              <h1 className="font-weight-bold title" style={{fontSize: '5rem'}}>{
                                dataLoader ? (
                                  <div className="d-flex">
                                    <Spinner
                                      animation="border"
                                      role="status"
                                      className="d-flex justify-content-center" />
                                  </div>
                                ): puestos_cubiertos && puestos_cubiertos.length > 0 ? Math.round(parseFloat(parseFloat(puestos_cubiertos[0].conteo) / parseFloat(puestos_existentes[0].conteo) * 100).toFixed(2)) : 0 }<small style={cardTitleStyle}>%</small></h1>
                              <h6 className="font-weight-bold text-uppercase mt-3">plazas cubiertos: {puestos_cubiertos && puestos_cubiertos.length > 0 ? puestos_cubiertos[0].conteo : ''}</h6>
                            </div>
                            <img className="icon" style={cardStyle} src={tea} alt="plazas cubiertas" srcset={tea} />
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col md="4">
                        <Card className="border-0 ">
                          <Card.Body className="dashboard-card dashboard-card-bl">
                            <div >
                              <h1 className="font-weight-bold title" style={{fontSize: '5rem'}}>{
                                dataLoader ? (
                                  <div className="d-flex">
                                    <Spinner
                                      animation="border"
                                      role="status"
                                      className="d-flex justify-content-center" />
                                  </div>
                                ): puestos_vacantes && puestos_vacantes.length > 0 ? Math.round(parseFloat(parseFloat(puestos_vacantes[0].conteo) / parseFloat(puestos_existentes[0].conteo) * 100).toFixed(2))  : 0 }<small style={cardTitleStyle}>%</small></h1>
                              <h6 className="font-weight-bold text-uppercase mt-3">plazas vacantes: {puestos_vacantes && puestos_vacantes.length > 0 ? puestos_vacantes[0].conteo : ''}</h6>
                            </div>
                            <img className="icon" style={cardStyle} src={jobOf} alt="Plazas vacantes" srcset={jobOf} />
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <Container fluid>
          <div className="pcj-body-dashboard shadow-lg">
            <Form className="mt-4 px-4" onSubmit={onSubmit} noValidate validated={validated}>
              <Form.Group as={Row} controlId="formAnio">
                <Form.Label column md="1">
                  Año
                </Form.Label>
                <Col md="3">
                  <Form.Control defaultValue={year} maxLength="4" pattern="\d*" required name="year" className="rounded-pill form-control-sm" placeholder="Año" />
                  <Form.Control.Feedback type="invalid">
                    <p className="m-0">* Se requiere un año valido</p>
                    <p>* El año debe se un entero por ejemplo 2021</p>
                    <p>* El año ingresado no puede ser mayor al actual</p>
                  </Form.Control.Feedback>
                </Col>
                <Col md="3">
                  <Button size="sm" variant="primary" className="rounded-pill" type="submit">Filtrar</Button>
                </Col>
              </Form.Group>
            </Form>
            <Card className="border-0 shadow bg-dark my-4">
              <Card.Body>
                <h5 className="text-white">Contrataciones vs salidas</h5>
                <Bar height={155} data={graphContVsSal} options={{
                  fill: false,
                  interaction: {
                    intersect: false
                  },
                  responsive: true,
                  legend: {
                      display: false,
                  }, 
                  scale: {
                    ticks: {
                      precision: 0
                    }
                  },
                  radius: 0
                }} />
              </Card.Body>
            </Card>
            <Row>
              <Col sm={12} md={5}>
                <Card className="border-0 shadow">
                  <Card.Body>
                    {/* <small>Personal por tipo de relación</small> */}
                    <h6>Personal por tipo de relación</h6>
                    <Pie 
                      data={graphTypeRel} 
                      height={155}
                      options={{
                        plugins:{
                          title: {
                            display: true,
                          },
                          legend: {
                            display: true,
                          }
                        }
                      }} />
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={12} md={7}>
                <Card className="border-0 shadow">
                  <Card.Body>
                    <h6>Empleados por centro de costo</h6>
                    <Bar height={155} data={graphceCo} options={{
                      scales: {
                        yAxes: [{
                          scaleLabel: {
                            display: true,
                            labelString: 'Cantidad de empleados'
                          }
                        }],
                        xAxes: [{
                          scaleLabel: {
                            display: true,
                            labelString: 'Centro de costo'
                          }
                        }],
                      } ,
                      indexAxis: 'y',
                      elements: {
                        bar: {
                          borderWidth: 2,
                        }
                      },
                      scale: {
                        ticks: {
                          precision: 0
                        }
                      },
                      responsive: true,
                      plugins: {
                        legend: {
                          position: 'top',
                          display: false
                        },
                        title: {
                          display: false,
                          text: 'Chart.js Bar Chart'
                        }
                      }
                    }} />
                    <hr />
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={12} md={6} className="mt-4">
                <Card className="border-0 shadow">
                  <Card.Body>
                    {/* <small>Personal por tipo de relación</small> */}
                    <h5>Personal por zona</h5>
                    <Bar height={350} data={graphPersonalZonaData} options={{
                      plugins: {
                        title: {
                          display: false,
                          text: 'Average rainfall per month',
                          fontSize: 20
                        },
                        legend: {
                          display: false,
                          position: 'right'
                        }
                      },
                      scale: {
                        ticks: {
                          precision: 0
                        }
                      }
                    }} />
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={12} md={6} className="mt-4">
                <Card className="border-0 shadow">
                  <Card.Body>
                    <h5>Personal por formación</h5>
                    <Bar height={350} data={graphFormAcademicData} options={{
                      responsive: true,
                      plugins: {
                        legend: {
                          position: 'top',
                        },
                        title: {
                          display: false,
                          text: 'Chart.js Bar Chart'
                        }
                      },
                      scale: {
                        ticks: {
                          precision: 0
                        }
                      }
                    }} />
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={12} md={4} className="mt-4">
                <Card className="border-0 shadow">
                  <Card.Body>
                    <h5>Personal país/empresa</h5>
                    <Bar height={350} data={graphpersonalPaisEmpresaData} options={{
                      responsive: true,
                      fill: true,
                      plugins: {
                        legend: {
                          position: 'top',
                          display: false
                        },
                        title: {
                          display: false,
                          text: 'Chart.js Bar Chart'
                        }
                      },
                      scale: {
                        ticks: {
                          precision: 0
                        }
                      }
                    }} />
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={12} md={4} className="mt-4">
                <Card className="border-0 shadow">
                  <Card.Body>
                    {/* <small>Personal por tipo de relación</small> */}
                    <h5>Personal por género</h5>
                    <Doughnut height={155} data={graphpersonalGenero} options={{
                      title: {
                        dislpay: true,
                        text: 'Average rainfall per month',
                        fontSize: 20
                      },
                      legend: {
                        display: true,
                        position: 'right'
                      }
                    }} />
                  </Card.Body>
                </Card>
              </Col>
              <Col sm={12} md={4} className="mt-4">
                <Card className="border-0 shadow">
                  <Card.Body>
                    {/* <small>FARINTER</small> */}
                    <h5>Personal por antigüedad laboral</h5>
                    <Bar height={350} data={graphAntLaboralData} options={{
                      responsive: true,
                      plugins: {
                        legend: {
                          position: 'top',
                        },
                        title: {
                          display: false,
                          text: 'Chart.js Bar Chart'
                        }
                      },
                      scale: {
                        ticks: {
                          precision: 0
                        }
                      }
                    }} />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Card className="border-0 mt-5">
              <Card.Body>
                {/* <small>Personal por tipo de relación</small> */}
                <h5>Plazas cubiertas (esctuctura organizativa)</h5>
                <Bar height={150} data={graphEstandarData} options={{
                  title: {
                    dislpay: true,
                    text: 'Average rainfall per month',
                    fontSize: 20,
                  },
                  legend: {
                    display: true,
                    position: 'right'
                  },
                  scale: {
                    ticks: {
                      precision: 0
                    }
                  }
                  
                  // ,
                  // scales:{
                  //   x:{ stacked: true},
                  //   y:{ stacked: true}
                  // }
                }}                  
                />
              </Card.Body>
            </Card>
          </div>
        </Container>
      </div>
    </>
  )
}

export default DashboardPositionH